import React from 'react';
import {
    IonButton, IonContent, IonCard, IonIcon, IonCardHeader, IonCardContent,
    IonCardTitle, IonImg, IonToolbar
} from '@ionic/react';
import {useTranslation} from 'react-i18next';
import {informationCircle, build, helpCircle, peopleCircle, alertCircle, book} from 'ionicons/icons';


function InfoScreen() {
    const {t} = useTranslation();
    return (<>
        <IonContent className="ion-padding">
            <div className="info-container">
                <IonImg src="/icon.svg" alt="Logo"/>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={informationCircle}/>{t('info.whatIs')}
                    </IonCardHeader>
                    <IonCardContent>{t('info.whatIsDesc')}</IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={build}/>{t('info.features')}</IonCardHeader>
                    <IonCardContent>
                        <p><b>{t('info.feature1bold')}</b> {t('info.feature1')}</p>
                        <p><b>{t('info.feature2bold')}</b> {t('info.feature2')}</p>
                    </IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={helpCircle}/>{t('info.whyImportant')}</IonCardHeader>
                    <IonCardContent>
                        <p>{t('info.whyImportantDesc1')}</p>
                    </IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={book}/>{t('info.howTo')}</IonCardHeader>
                    <IonCardContent>
                        <p>{t('info.howTo1')}</p>
                        <p>{t('info.howTo2')}</p>
                        <p>{t('info.howTo3')}</p>
                    </IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={peopleCircle}/>{t('info.support')}</IonCardHeader>
                    <IonCardContent>{t('info.supportDesc')}
                        <div className="button-container">
                            <IonButton href="mailto:info@buscapk.es"
                                       size="small"
                                       subject="Incidencia%20con%20la%20aplicación"
                                       target="_blank">{t('info.reportIssue')}
                            </IonButton>
                        </div>

                        <p className="ion-text-justify">{t('info.followUs')} <a
                            href="https://twitter.com/buscapk">@buscapk</a>
                        </p>
                    </IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonIcon icon={alertCircle}/>{t('info.legalNotice')}</IonCardHeader>
                    <IonCardContent>{t('info.legalNoticeDesc')}</IonCardContent>
                </IonCard>
                <IonCard>
                    <IonCardHeader>{t('info.credits')}</IonCardHeader>
                    <IonCardContent className="ion-text-justify">{t('info.creditsDesc')} <a
                        href="https://creativecommons.org/licenses/by/4.0/deed.es">CC-BY 4.0</a> <a
                        href="www.scne.es"> scne.es</a></IonCardContent>
                </IonCard>
            </div>
        </IonContent>
    </>);
}

export default InfoScreen;